
import { Button, Table } from 'antd'
import React from 'react'
import { mapAccountingRecordDataRange } from '../../../axios/dictionaries'
import { CustomCol, CustomRow } from '../../../components/Custom'
import DetailTitle from '../../../components/DetailTitle'
import {
    apiAccountingRecordConfirmationCompensationExport,
    apiAccountingRecordRefundConfirmationExport,
    fetchAccountingRecordRefundConfirmation
} from '../../../services/accountingRecord'
import { findDict, handleExportParams, ToParamForObject } from '../../../utils'
/** 
 * @Author: zhao - 🍉
 * @Date: 2021-12-20 17:27:12
 * @LastEditTime: 2021-12-21 10:04:01
 * @LastEditors: zhao - 🍉
 * @Description: 退款确认书详情
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/components/RefundConfirmationView.jsx
 */

class RefundConfirmationView extends React.Component{
    constructor() {
        super()
        this.state = {
            refundConfirmationData: {},
            loan:false,
            isJh:0,
        }
    }
    componentDidMount() {
        this.postAccountingRecordRefundConfirmation()
    }

    postAccountingRecordRefundConfirmation() {
        const data = { accountingRecordLogId: this.props.accountingRecordLogId }
        fetchAccountingRecordRefundConfirmation(data).then(res => {
            this.setState({ refundConfirmationData: res,loan: res.loan,isJh:(res.isJh==null?0:res.isJh)})
        })
    }
    render(){
        const { labelWidth } = this.props
        const { refundConfirmationData = {} } = this.state

        const deductFeesColumns = [
            { title: '费用名称 | 楼栋名称', dataIndex: 'costName'
            ,render(text, record, index) {
                return <span>
                <div>{record.costName ? record.costName : ''}</div>
                <div>{record.buildingName ? record.buildingName : ''}</div>
            </span>
            }
            },
            { title: '费用', dataIndex: 'splitAmount' },
        ]

        const exportParmas = ToParamForObject({ 
            accountingRecordLogId: this.props.accountingRecordLogId,
            ...handleExportParams()
        })
        const exportUrl = apiAccountingRecordRefundConfirmationExport + '?' + exportParmas
        const exportDcqrsUrl = apiAccountingRecordConfirmationCompensationExport + '?' + exportParmas
        return (
            <div>
                {this.state.loan && this.state.isJh!=1 ?<Button type="primary" icon="export" href={exportDcqrsUrl}
                         style={{position: 'absolute', right: 150, top: 50}}>
                    导出代偿确认书
                </Button>:null
                }
                <Button type="primary" icon="export" href={exportUrl} style={{position: 'absolute', right: 0, top: 50}}>
                    导出退款确认书
                </Button>
                <DetailTitle title="基础信息" />

                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="商户名称">
                        {refundConfirmationData.merchantName}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="商户企业号">
                        {refundConfirmationData.enterpriseUserNumber}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="汇集期数">
                        {refundConfirmationData.collectionPeriod}
                    </CustomCol>

                </CustomRow>
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="开始日期">
                        {refundConfirmationData.startDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结束日期">
                        {refundConfirmationData.endDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="所属月份">
                        {refundConfirmationData.month}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>

                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="进账总额">
                        {refundConfirmationData.totalReceipts}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="扣款费用总额">
                        {refundConfirmationData.deductFeesTotal}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结余总额">
                        {refundConfirmationData.balanceTotal}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>

                    {/*<CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="数据范围">*/}
                    {/*    {findDict(mapAccountingRecordDataRange, refundConfirmationData.dataRange).title }*/}
                    {/*</CustomCol>*/}
                    {/*<CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="楼栋">*/}
                    {/*    {refundConfirmationData.buildingNames}*/}
                    {/*</CustomCol>*/}
                    
                </CustomRow>
                <DetailTitle title="扣款费用明细" />
                <Table columns={deductFeesColumns} dataSource={refundConfirmationData.deductFeesList} scroll={{x: 900}} />
            </div>
        )
    }
}

export default RefundConfirmationView


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/RefundConfirmationView.jsx